import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import Styles from './PlanScorecardQuickResults.css'

@CSSModules(Styles, {allowMultiple:true})
export default class PlanScorecardQuickResults extends Component {
  static propTypes = {
    planData: PropTypes.object,
    showLabels: PropTypes.bool
  }
  constructor(props) {
    super(props)
  }

  render() {
    if (!this.props.planData) { return null }
    const { planData } = this.props

    let hasPrimaryPlanLogo = false
    let primaryPlanLogo = null
    try {
      primaryPlanLogo = require('../../../static/images/plans/'+planData.path+'.png')
      hasPrimaryPlanLogo = true
    }
    catch (e) {
      console.log('')
    }

    const totCount = planData.plan_option_count
    const esgCount = planData.plan_option_sri_count
    const esgPerc =  format.perc(planData.allocations.sri / planData.plan_assets)
    const hasEsg = esgCount > 0

    const climateRiskInvestment = format.money(
      planData.screen_results.fff[0] +
        planData.screen_results.fff[1] +
        planData.screen_results.dff[0] +
        planData.screen_results.dff[1],
      true, 'USD', true, 0
    )
    //
    return (
      <div styleName='psqr-wrap'>
        <div styleName='psqr-flex'>

          <div styleName='psqr-cell cell-name-logo'>
            {
              hasPrimaryPlanLogo ?
                (
                  <img
                    styleName='name-logo'
                    src={primaryPlanLogo}
                    alt={planData.short_name}
                  />
                ) :
                <div styleName='psqr-label'>
                  {planData.short_name}
                </div>
            }
          </div>

          <div styleName='psqr-cell'>
            {
              this.props.showLabels ?
                (
                  <div styleName='psqr-label'>
                    Sustainable default investment?
                  </div>
                ) :
                null
            }
            <div styleName='psqr-no-value'>
              No
            </div>
          </div>

          <div styleName='psqr-cell'>
            {
              this.props.showLabels ?
                (
                  <div styleName='psqr-label'>
                    Sustainable investment options?
                  </div>
                ) :
                null
            }
            {
              hasEsg ?
                (
                  <div styleName='psqr-yes-value'>
                    {esgCount} / {totCount} <span styleName='psqr-yes-value-small'>options</span>
                    <br/>
                    {esgPerc} <span styleName='psqr-yes-value-small'>invested</span>
                  </div>
                ) :
                (
                  <div styleName='psqr-no-value'>
                    No
                  </div>
                )
            }
          </div>

          <div styleName='psqr-cell'>
            {
              this.props.showLabels ?
                (
                  <div styleName='psqr-label'>
                    Climate-risk investments $USD
                  </div>
                ) :
                null
            }
            <div styleName='psqr-num-value'>
              {climateRiskInvestment}
            </div>
          </div>

        </div>
      </div>
    )
  }
}